module.exports = __webpack_public_path__ + "static/half-section-with-pattern-c683eb13dbb781859f38ff1d168b3fef.png";